require('./style.scss')
angular = require('angular')
paginator = require('../../../common/resource/paginator')
tagInput = require('./tag-input')
class DeviceBulkAction
  @$inject: ["$uibModal"]
  constructor: (@modal)->
  open: (options)->
    {model} = options
    if model is 'BulkAddTag'
      template = require("./add-tag.pug")
    else if model is 'BulkCsvUpdate'
      template = require("./csv-update.pug")
    else
      template = require("./index.pug")
    instance = @modal.open
      template: template
      controller: DeviceBulkActionModalCtrl             
      controllerAs: '$ctrl'
      backdrop: options.backdrop
      resolve: 
        options: ()->
          return options?={}

    return instance.result

class DeviceBulkActionModalCtrl
  @$inject = ['$uibModalInstance','options', 'Device']
  constructor: ($uibModalInstance, options, Device)->
    @DeviceServ = new Device
    @fileName = ""
    @options = options
    @dirty = false
    @fileHref = "http://0.0.0.0:8088/api/devices/download/device_csv_update_template.csv"
    if options.devices
      @devices = options.devices
    @instance = $uibModalInstance
    @inputTagList = [] 
    {@title="Confirm", @msg="Confirm to do this?"} = options
  accordionStatus: 
    sampleOpen: false
    successOpen: false
    failOpen: false
  oneAtATime: false
  errMsg: undefined
  invalidDevices: []
  validDevices: []

  download: ()=>
    console.log "download "
    filename = "device_csv_update_template.csv"
    @DeviceServ.download filename
    .then (result)->
      filename = "sample.csv"
      blob = new Blob [result.data]
      if window.navigator.msSaveOrOpenBlob
        window.navigator.msSaveBlob(result.data, filename);
      else
        a = window.document.createElement("a");
        a.href = window.URL.createObjectURL(blob, type: "text/plain")
        a.download = filename
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

  upload: ($file)=>
    @fileName =  ""
    @errMsg = undefined
    @accordionStatus.successOpen = false
    @accordionStatus.failOpen = false  
    @invalidDevices = []
    @validDevices = []
    @DeviceServ.bulkCsvUpdate $file
    .then (result)=>
      @fileName = $file.name
      @errMsg = result.errMsg
      @invalidDevices = result.invalidDevices
      @validDevices = result.validDevices
      @accordionStatus.successOpen = true
      @accordionStatus.failOpen = true
      if @validDevices.length > 0
        @dirty = true

  confirm: ()->
    @instance.close(@inputTagList)
  cancel: ()->    
    @instance.dismiss "cancelled"

  csv_confirm: ()->
    @instance.close()
  csv_cancel: ()-> 
      @instance.close @dirty

class DeviceBulkActionModalDirective
  @$inject: ["$rootScope", "$injector", "$timeout", "$filter"]
  constructor: ($rootScope, $injector, $timeout, $filter)->
    class Resource
      scope: true
      bindToController: true
      controllerAs: "$resource"
      controller: ($scope, $element, $attrs)->
        @limit = $attrs.limit ? 5
        $scope.$watch $attrs.deviceModal, (val)=>
          if val
            @list = @dataset = val
            $scope.$pagination =
              total: val.length
              limit: @limit
              page: 1
            @move(1)
        , true

        @move = (page) =>
          if @list[0]?.device? or @list is undefined or @list.length is 0
            $scope.$parent.listOfCurrentDevice = @list
          start = (page - 1) * @limit
          $scope.$dataset = $filter("limitTo")(@list, @limit, start)


        @search = (term)=>
          if !term or term.length is 0
            term = ''
          @list = $filter('filter')(@dataset, term);
          $scope.$pagination =
              total: @list.length
              limit: @limit
              page: 1
          @move(1)
             

        return @
    return new Resource()


pkg = angular
  .module 'device.bulk.action.modal', []
  .service "deviceBulkAction", DeviceBulkAction
  .directive "deviceModal", DeviceBulkActionModalDirective
  .directive "tagInput", tagInput
  .directive "deviceBulkActionPaginator", paginator
  
module.exports = pkg.name


// WEBPACK FOOTER //
// ./src/component/device/bulk-action/index.coffee